import {
  AlliesScreen,
  AmountsScreen,
  AppCommerceVersion,
  AppVersion,
  BannersScreen,
  CardsCostLimitScreen,
  CardsQuery,
  CardsScreen,
  CategoriesPaymentScreen,
  CategoriesRechargeScreen,
  CommerceFeaturesFlagScreen,
  CommercialCategoryScreen,
  CommissionsScreen,
  Dashboard,
  DeviceScreen,
  DistributionCenterScreen,
  DistributionPOS,
  Documentation,
  DocumentConfigByProduct,
  FeaturedScreen,
  FeesScreen,
  NationalHolidaysScreen,
  PaymentsLinks,
  PaymentMethodsScreen,
  PersonFeaturesFlagScreen,
  PromoCategories,
  PromotionsAppScreen,
  PromotionsScreen,
  ProvidersPaymentScreen,
  ProvidersScreen,
  ReadOnlyAlliesScreen,
  ReadOnlyAmountsScreen,
  ReadOnlyAppCommerceVersion,
  ReadOnlyAppVersion,
  ReadOnlyBannersScreen,
  ReadOnlyCardsQuery,
  ReadOnlyCardsScreen,
  ReadOnlyCategoriesPaymentScreen,
  ReadOnlyCategoriesRechargeScreen,
  ReadOnlyCommerceFeaturesFlagScreen,
  ReadOnlyCommercialCategoryScreen,
  ReadOnlyCommissionsScreen,
  ReadOnlyDeviceScreen,
  ReadOnlyDistributionCenterScreen,
  ReadOnlyDistributionPOS,
  ReadOnlyDocumentation,
  ReadOnlyFeaturedScreen,
  ReadOnlyFeesScreen,
  ReadOnlyNationalHolidaysScreen,
  ReadOnlyPaymentsLinks,
  ReadOnlyPersonFeaturesFlagScreen,
  ReadOnlyPromoCategories,
  ReadOnlyPromotionsAppScreen,
  ReadOnlyPromotionsScreen,
  ReadOnlyProvidersPaymentScreen,
  ReadOnlyProvidersScreen,
  ReadOnlyReferralsScreen,
  ReadOnlyRemittancesNoUser,
  ReadOnlyRemittancesScreen,
  ReadOnlyRepositionScreen,
  ReadOnlyRolAssignment,
  ReadOnlyRolesRegisterScreen,
  ReadOnlyScreensRolesScreen,
  ReadOnlySegmentationScreen,
  ReadOnlyTapToPhone,
  ReadOnlyTaxesScreen,
  ReadOnlyTypePromotionsScreen,
  ReadOnlyUmbralIF01FeaturesFlagScreen,
  ReferralsScreen,
  RemittancesNoUser,
  RemittancesScreen,
  RepositionScreen,
  RolAssignment,
  RolesRegisterScreen,
  ScreensRolesScreen,
  SegmentationScreen,
  TapToPhone,
  TaxesScreen,
  TypePromotionsScreen,
  UmbralIF01FeaturesFlagScreen,
  CommerceInfoScreen,
} from "@/screens";
import {
  AccountBalance,
  ScreenShare,
  ScreenLockLandscape,
  PeopleSharp,
  Build,
  AttachMoney,
  Money,
  People,
  Power,
  PersonPinCircle,
  MonetizationOn,
  PinDrop,
  MonetizationOnOutlined,
  Search,
  Storefront,
  DevicesOther,
  LocationCity,
  TouchApp,
  MoneyOutlined,
  FormatListNumberedOutlined,
  Loyalty,
  Redeem,
  Category,
  CardGiftcard,
  Link as LinkIcon,
  RssFeed,
  StorefrontOutlined,
  ImportantDevicesOutlined,
  DateRange,
  FileCopy,
  Folder,
  Settings,
} from "@material-ui/icons";
import DashboardIcon from "@material-ui/icons/Dashboard";
import { PrivateRoutesComplete } from "@/types/generals";
import EngineeringIcon from "@mui/icons-material/Engineering";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import SegmentIcon from "@mui/icons-material/Segment";
import LabelImportantIcon from "@mui/icons-material/LabelImportant";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import PaymentsIcon from "@mui/icons-material/Payments";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";

export const PRIVATE_ROUTES_COMPLETE: PrivateRoutesComplete = {
  dashboard: {
    navigation: "dashboard",
    title: "Dashboard - ⚠ Data de ejemplo ⚠",
    icon: <DashboardIcon />,
    screen: <Dashboard />,
    screenReadOnly: <Dashboard />,
  },
  administrator: {
    title: "Administrador de roles",
    icon: <EngineeringIcon />,
    colapse: "administrator",
    sections: [
      {
        navigation: "rol_assignment",
        title: "Asignación de roles",
        icon: <PeopleSharp />,
        screen: <RolAssignment />,
        screenReadOnly: <ReadOnlyRolAssignment />, // DO NOT USE THIS WAY, PLASE USE THE READONLY PROPS
      },
      {
        navigation: "rol_register",
        title: "Registro de roles",
        icon: <ScreenLockLandscape />,
        screen: <RolesRegisterScreen />,
        screenReadOnly: <ReadOnlyRolesRegisterScreen />, // DO NOT USE THIS WAY, PLASE USE THE READONLY PROPS
      },
      {
        navigation: "rol_screens",
        title: "Registro de secciones",
        icon: <ScreenShare />,
        screen: <ScreensRolesScreen />,
        screenReadOnly: <ReadOnlyScreensRolesScreen />, // DO NOT USE THIS WAY, PLASE USE THE READONLY PROPS
      },
    ],
  },
  mantainance: {
    title: "Mantenimiento",
    icon: <Build />,
    colapse: "mantainance",
    sections: [
      {
        navigation: "taxes",
        title: "Impuestos",
        icon: <AccountBalance />,
        screen: <TaxesScreen />,
        screenReadOnly: <ReadOnlyTaxesScreen />,
      },
      {
        navigation: "commissions",
        title: "Comisiones",
        icon: <AttachMoney />,
        screen: <CommissionsScreen />,
        screenReadOnly: <ReadOnlyCommissionsScreen />,
      },
      {
        navigation: "fees",
        title: "Comisiones App",
        icon: <AttachMoney />,
        screen: <FeesScreen />,
        screenReadOnly: <ReadOnlyFeesScreen />,
      },
      {
        navigation: "amounts",
        title: "Limites",
        icon: <Money />,
        screen: <AmountsScreen />,
        screenReadOnly: <ReadOnlyAmountsScreen />,
      },
    ],
  },
  referrals: {
    title: "Referidos",
    icon: <People />,
    colapse: "referrals",
    sections: [
      {
        navigation: "referrals",
        title: "Maestro",
        icon: <PersonPinCircle />,
        screen: <ReferralsScreen />,
        screenReadOnly: <ReadOnlyReferralsScreen />,
      },
      {
        navigation: "allies",
        title: "Super Aliados",
        icon: <Power />,
        screen: <AlliesScreen />,
        screenReadOnly: <ReadOnlyAlliesScreen />,
      },
    ],
  },
  segmentation: {
    navigation: "segmentation",
    title: "Segmentación",
    icon: <SegmentIcon />,
    screen: <SegmentationScreen />,
    screenReadOnly: <ReadOnlySegmentationScreen />,
  },
  documentation: {
    title: "Documentación de arraigo",
    icon: <FileCopy />,
    colapse: "documentation",
    sections: [
      {
        navigation: "documentation",
        title: "Documentos",
        icon: <Folder />,
        screen: <Documentation />,
        screenReadOnly: <ReadOnlyDocumentation />,
      },
      {
        navigation: "config_by_product",
        title: "Configuración de producto",
        icon: <Settings />,
        screen: <DocumentConfigByProduct />,
        screenReadOnly: <DocumentConfigByProduct />,
      },
    ],
  },
  remittance: {
    title: "Remesas",
    icon: <LocalAtmIcon />,
    colapse: "remittance",
    sections: [
      {
        navigation: "remittances",
        title: "Tasa USD",
        icon: <MonetizationOn />,
        screen: <RemittancesScreen />,
        screenReadOnly: <ReadOnlyRemittancesScreen />,
      },
      {
        navigation: "expiration_date_remittance",
        title: "Vencimiento No User",
        icon: <DateRange />,
        screen: <RemittancesNoUser />,
        screenReadOnly: <ReadOnlyRemittancesNoUser />,
      },
      // {
      //   navigation: 'remittances_no_user',
      //   title: 'Remesas No User',
      //   icon: <MonetizationOnOutlined />,
      //   // screen: <RemittancesScreen />,
      //   // screenReadOnly: <ReadOnlyRemittancesScreen />
      // },
    ],
  },
  feature_flag: {
    title: "Feature flag",
    icon: <LabelImportantIcon />,
    colapse: "feature_flag",
    sections: [
      {
        navigation: "features-flag",
        title: "App Personas",
        icon: <People />,
        screen: <PersonFeaturesFlagScreen />,
        screenReadOnly: <ReadOnlyPersonFeaturesFlagScreen />,
      },
      {
        navigation: "commerce-features-flag",
        title: "App Comercios",
        icon: <Storefront />,
        screen: <CommerceFeaturesFlagScreen />,
        screenReadOnly: <ReadOnlyCommerceFeaturesFlagScreen />,
      },
      {
        navigation: "commerce-web-features-flag",
        title: "Web Comercios",
        icon: <Storefront />,
        screen: <CommerceFeaturesFlagScreen />,
        screenReadOnly: <ReadOnlyCommerceFeaturesFlagScreen />,
      },
      {
        navigation: "if01-features-flag",
        title: "IF01",
        icon: <Storefront />,
        screen: <UmbralIF01FeaturesFlagScreen />,
        screenReadOnly: <ReadOnlyUmbralIF01FeaturesFlagScreen />,
      },
    ],
  },
  request: {
    title: "Solicitud de tarjetas",
    icon: <CreditScoreIcon />,
    colapse: "request",
    sections: [
      {
        navigation: "distributionZone",
        title: "Zonas de distribución",
        icon: <LocationCity />,
        screen: <DistributionPOS type="request-card" />,
        screenReadOnly: <ReadOnlyDistributionPOS type="request-card" />,
      },
      {
        navigation: "distributionCenter",
        title: "Centros de distribución",
        icon: <PinDrop />,
        screen: <DistributionCenterScreen />,
        screenReadOnly: <ReadOnlyDistributionCenterScreen />,
      },
    ],
  },
  cards: {
    title: "Tarjetas",
    icon: <PriceChangeIcon />,
    colapse: "cards",
    sections: [
      {
        navigation: "cards",
        title: "Costo por solicitud",
        icon: <MonetizationOnOutlined />,
        screen: <CardsScreen />,
        screenReadOnly: <ReadOnlyCardsScreen />,
      },
      {
        navigation: "limitRepos",
        title: "límite de reposiciones",
        icon: <Money />,
        screen: <RepositionScreen />,
        screenReadOnly: <ReadOnlyRepositionScreen />,
      },
      {
        navigation: "cardsQuery",
        title: "Consulta",
        icon: <Search />,
        screen: <CardsQuery />,
        screenReadOnly: <ReadOnlyCardsQuery />,
      },
    ],
  },
  credit_card: {
    title: "Tarjetas de crédito",
    icon: <CreditCardIcon />,
    colapse: "credit_card",
    sections: [
      {
        navigation: "card_cost_limit",
        title: "Límites y costos",
        icon: <MonetizationOnOutlined />,
        screen: <CardsCostLimitScreen permissionToEdit={true} />,
        screenReadOnly: <CardsCostLimitScreen permissionToEdit={false} />,
      },
    ],
  },
  payments_link: {
    title: "Comercios",
    icon: <Storefront />,
    colapse: "payments_link",
    sections: [
      {
        navigation: "payments_link",
        title: "Link de pagos",
        icon: <LinkIcon />,
        screen: <PaymentsLinks />,
        screenReadOnly: <ReadOnlyPaymentsLinks />,
      },
      {
        navigation: "tap_to_phone",
        title: "Tap to phone",
        icon: <RssFeed />,
        screen: <TapToPhone />,
        screenReadOnly: <ReadOnlyTapToPhone />,
      },
      {
        navigation: "payment_methods",
        title: "Medios de pago",
        icon: <Money />,
        screen: <PaymentMethodsScreen />,
        screenReadOnly: <PaymentMethodsScreen readOnly={true} />,
      },
    ],
  },
  commerce_mantainance: {
    title: "Mantenimiento comercios",
    icon: <MiscellaneousServicesIcon />,
    colapse: "commerce_mantainance",
    sections: [
      {
        navigation: "commercial-category",
        title: "Categoría de comercios",
        icon: <Storefront />,
        screen: <CommercialCategoryScreen />,
        screenReadOnly: <ReadOnlyCommercialCategoryScreen />,
      },
      {
        navigation: "commerce-info",
        title: "Información de comercios",
        icon: <Storefront />,
        screen: <CommerceInfoScreen />,
        screenReadOnly: <CommerceInfoScreen />,
      },
    ],
  },
  mercadeo: {
    title: "Mercadeo",
    icon: <Storefront />,
    colapse: "mercadeo",
    sections: [
      {
        navigation: "banners",
        title: "Banners Promocionales",
        icon: <MonetizationOnOutlined />,
        screen: <BannersScreen />,
        screenReadOnly: <ReadOnlyBannersScreen />,
      },
      {
        navigation: "featured",
        title: "Promociones Destacadas",
        icon: <ImportantDevicesOutlined />,
        screen: <FeaturedScreen />,
        screenReadOnly: <ReadOnlyFeaturedScreen />,
      },
      {
        navigation: "promotionsCategories",
        title: "Categorías Promociones",
        icon: <Loyalty />,
        screen: <PromoCategories />,
        screenReadOnly: <ReadOnlyPromoCategories />,
      },
      {
        navigation: "typePromotions",
        title: "Tipo de promociones",
        icon: <FormatListNumberedOutlined />,
        screen: <TypePromotionsScreen />,
        screenReadOnly: <ReadOnlyTypePromotionsScreen />,
      },
      {
        navigation: "promotions_app_screen",
        title: "Promociones Billet",
        icon: <Redeem />,
        screen: <PromotionsAppScreen />,
        screenReadOnly: <ReadOnlyPromotionsAppScreen />,
      },
      {
        navigation: "promotions",
        title: "Promociones Cashin",
        icon: <MoneyOutlined />,
        screen: <PromotionsScreen />,
        screenReadOnly: <ReadOnlyPromotionsScreen />,
      },
    ],
  },
  pos: {
    title: "POS",
    icon: <Build />,
    colapse: "pos",
    sections: [
      {
        navigation: "posDevice",
        title: "Dispositivo",
        icon: <DevicesOther />,
        screen: <DeviceScreen />,
        screenReadOnly: <ReadOnlyDeviceScreen />,
      },
      {
        navigation: "distributionPos",
        title: "Distribución",
        icon: <LocationCity />,
        screen: <DistributionPOS />,
        screenReadOnly: <ReadOnlyDistributionPOS />,
      },
    ],
  },
  payment: {
    title: "Pago de servicios",
    icon: <PaymentsIcon />,
    colapse: "payment",
    sections: [
      {
        navigation: "providers_service_pay",
        title: "Proveedores",
        icon: <StorefrontOutlined />,
        screen: <ProvidersPaymentScreen />,
        screenReadOnly: <ReadOnlyProvidersPaymentScreen />,
      },
      {
        navigation: "categories_service_payment",
        title: "Categorías",
        icon: <Category />,
        screen: <CategoriesPaymentScreen />,
        screenReadOnly: <ReadOnlyCategoriesPaymentScreen />,
      },
    ],
  },
  recharge: {
    title: "Recarga de servicios",
    icon: <CardGiftcard />,
    colapse: "recharge",
    sections: [
      {
        navigation: "providers",
        title: "Proveedores",
        icon: <StorefrontOutlined />,
        screen: <ProvidersScreen />,
        screenReadOnly: <ReadOnlyProvidersScreen />,
      },
      {
        navigation: "categories_service_recharge",
        title: "Categorías",
        icon: <Category />,
        screen: <CategoriesRechargeScreen />,
        screenReadOnly: <ReadOnlyCategoriesRechargeScreen />,
      },
    ],
  },
  national_holidays: {
    navigation: "national_holidays",
    title: "Días feriados",
    icon: <DateRange />,
    screen: <NationalHolidaysScreen />,
    screenReadOnly: <ReadOnlyNationalHolidaysScreen />, // DO NOT USE THIS WAY, PLASE USE THE READONLY PROPS
  },
  versions: {
    title: "Versionamiento App",
    icon: <TouchApp />,
    colapse: "versions",
    sections: [
      {
        navigation: "appversion",
        title: "App Persona",
        icon: <People />,
        screen: <AppVersion />,
        screenReadOnly: <ReadOnlyAppVersion />, // DO NOT USE THIS WAY, PLASE USE THE READONLY PROPS
      },
      {
        navigation: "appcommerceversion",
        title: "App Comercios",
        icon: <Storefront />,
        screen: <AppCommerceVersion />,
        screenReadOnly: <ReadOnlyAppCommerceVersion />, // DO NOT USE THIS WAY, PLASE USE THE READONLY PROPS
      },
    ],
  },
};
